/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Builder_Result_Action_Target_RequiredInputs */



/**
* | output |
* | --- |
* | "Pick the dataset and the table the row is added to." |
*
* @param {Agent_Builder_Result_Action_Target_RequiredInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_builder_result_action_target_required = /** @type {((inputs?: Agent_Builder_Result_Action_Target_RequiredInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Builder_Result_Action_Target_RequiredInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Wählen Sie den Datensatz und die Tabelle, zu der die Zeile hinzugefügt wird.")
	return /** @type {LocalizedString} */ ("Pick the dataset and the table the row is added to.")
});